import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { TipoAtualizacaoEnum } from '../rede-especial-enuns';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-aceitar-acordo-dialog',
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <h2 mat-dialog-title>
          {{
            acordosSelecionados && acordosSelecionados.length > 1
              ? 'Aprovar Acordos'
              : 'Aprovar Acordo'
          }}
        </h2>
        <button
          mat-icon-button
          [mat-dialog-close]="false"
          class="close-button"
          matTooltip="Fechar diálogo"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="dialog-content">
        <div
          class="sumarizacao-acordos"
          *ngIf="acordosSelecionados && acordosSelecionados.length > 0"
        >
          <h4>Você está prestes a aprovar o(s) seguinte(s) acordo(s):</h4>
          <ul>
            <li *ngFor="let acordo of acordosSelecionados">
              Acordo Nº:
              {{ acordo.codAcordo || acordo.codAep || acordo.codAdc }} Frota:
              {{ acordo.razaoSocialFrota }}
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="col-12 text-end">
            <button mat-button class="btn-acao" (click)="onCancelar()">
              Voltar
            </button>
            <button
              mat-raised-button
              class="btn-acao btn-confirmar"
              (click)="onConfirmar()"
              [disabled]="loading"
            >
              Aprovar
              {{
                acordosSelecionados && acordosSelecionados.length > 1
                  ? 'Acordos'
                  : 'Acordo'
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      ::ng-deep {
        .mat-dialog-container {
          padding: 0 !important;
        }
      }

      :host {
        .dialog-container {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          overflow: hidden;
          border-radius: var(--border-radius-sm);

          .dialog-header {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: nowrap;
            background-color: var(--cor-terceira) !important;
            color: var(--cor-fundo-tela);
            padding: 0 vars(--spacing-lg);
            min-height: 50px;
            max-height: 50px;
            min-width: 100%;
            border-top-left-radius: var(--border-radius-sm);
            border-top-right-radius: var(--border-radius-sm);
            position: relative;
            padding: 8px;

            h2 {
              margin: 0;
              font-weight: 500;
              flex-grow: 1;
              color: var(--cor-fundo-tela) !important;
              margin-left: 2px;
              line-height: 1;
              display: flex;
              align-items: center;
            }

            .close-button {
              &:hover {
                background-color: rgba(255, 255, 255, 0.1);
                border-radius: var(--border-radius-sm);
                cursor: pointer;
              }
            }
          }
        }

        .dialog-content {
          padding: var(--spacing-md);
          background-color: #f5f5f5;
          overflow-y: auto;
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
        }

        .sumarizacao-acordos {
          margin-bottom: 24px;

          h4 {
            margin-bottom: 16px;
            font-size: 16px;
          }

          ul {
            list-style-type: disc;
            padding-left: 20px;
            margin-bottom: 16px;
          }

          li {
            margin-bottom: 8px;
            font-size: 14px;
          }
        }

        .text-end {
          text-align: right;
          padding: 16px;
          gap: 8px;

          button {
            margin-left: 8px;
          }
        }

        .btn-acao {
          width: 200px;
          height: 56px;
          font-weight: bold;
          font-size: 16px;
          border-radius: 12px;
          border: 1px solid var(--cor-doc-pri-1);
          background-color: var(--cor-segunda);
          color: #fff;
        }

        .btn-confirmar {
          border: 1px solid var(--cor-doc-pri-3);
          background-color: var(--cor-doc-pri-3);
        }
      }
    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
})
export class AceitarAcordoDialogComponent {
  public loading = false;
  constructor(
    public dialogRef: MatDialogRef<AceitarAcordoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public acordosSelecionados: any,
    private service: RedeEspecialService,
    private snackBar: SnackBarService
  ) {}

  onCancelar(): void {
    this.dialogRef.close();
  }

  onConfirmar(): void {
    this.loading = true;

    const selecionados = this.acordosSelecionados.map((acordo: any) => ({
      codAcordo: acordo.codAcordo,
      codSituacao: acordo.codSituacao,
      codAep: acordo.codAep,
      razaoSocialFrota: acordo.razaoSocialFrota,
    }));

    const payloadAprovar = {
      listaAcordos: selecionados,
      dscUsuario: this.service.usuario.retorno.login,
      tipoAtualizacao: TipoAtualizacaoEnum.APROVAR,
    };

    this.service.aprovarOuRejeitarAcordos(payloadAprovar).subscribe({
      next: (res) => {
        this.snackBar.flashMessage(
          'Acordo(s) aprovado(s) com sucesso!',
          ['snackbar-success'],
          'Fechar',
          2
        );
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.snackBar.flashMessage(
          'Erro ao aprovar acordos!',
          ['snackbar-error'],
          'Fechar',
          2
        );
        this.dialogRef.close(false);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
